t = require('views/internal/teacup-with-helpers')('header_info_menu')
socialUrls = require('locale').social

module.exports = t.renderable ->

  t.div '.js-fill-tip'

  t.a { class: 'next-tip-link js-new-tip', href: "#" }, t.l('get-new-tip')

  t.hr()

  entry = (href, metapagename, key) ->
    t.li '.meta-link-list-item', ->
      t.a
        class: 'meta-link-list-item-link js-meta-page-link'
        href: href
        'data-metapagename': metapagename
        target: '_blank'
      , t.l(key)

  t.ul '.meta-link-list', ->
    entry '/tour', 'Tour', 'tour'
    entry '/pricing', 'Pricing', 'pricing'
    entry '/platforms', 'Apps', 'apps'
    entry socialUrls.blog, 'Blog', 'blog'
    entry '/privacy', 'Privacy', 'privacy'

    t.span '.js-more-menu-button', ->
      t.li '.meta-link-list-item', ->
        t.a
          class: 'meta-link-list-item-link js-meta-page-more-link'
          href: "#"
        , t.l('more')

    t.span '.js-more-menu.hide', ->
      entry 'http://help.trello.com', 'Help', 'help'
      entry '/jobs', 'Jobs', 'jobs'
      entry 'https://developers.trello.com', 'Developers', 'developers'
      entry '/about', 'About', 'about'
      entry '/legal', 'Legal', 'legal'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_info_menu.coffee